angular.module('app.directives.curve', []).
directive('curve',[
	'$filter',
	function($filter) {
		var obj = {
			x : 0,
			startX : 0,
			initValue : 0,
          scope:
            {
                values : '=values',
                axisY: '=',
            },
           restrict:'AE',
           templateUrl: 'views/form/curve.html',



      // -------------------------------------------//
     //              Link Function
    // -------------------------------------------//
           link: function(scope,element, attrs, controller)
              {
              	//var isTouch = !!('ontouchstart' in window);
              	//create canvas and context
              	scope.offsetY = 10;
              	scope.$watch('values',function(newvalue){
              		scope.draw();
              	},true);
              	scope.$on('curve_update',function(){
              		scope.draw();
              	});
				var canvas = document.createElement('canvas');
				canvas.id = 'curveCanvas';
				//canvas.id = options.canvasId;
				canvas.width = 750;
                canvas.height = 355;

				element.append(canvas);
				var ctx = canvas.getContext('2d');
				ctx.translate(0.5, 0.5);
				scope.offsetX = 0;

                scope.recalculateBounds = function() {
                    let minY = scope.axisY.min;
                    let maxY = scope.axisY.max;
    
                    if (minY === undefined) {
                        minY = 0;
                    }
                    if (maxY === undefined) {
                        maxY = 65;
                    }
    
                    if (scope.axisY.userMin !== undefined) {
                        minY = scope.axisY.userMin;
                    }
                    if (scope.axisY.userMax !== undefined) {
                        maxY = scope.axisY.userMax;
                    }
    
                    return { 'userMin': minY, 'userMax': maxY };
                };

				scope.draw = function(){
                    const bounds = scope.recalculateBounds();
                    let userMin = bounds.userMin;
                    let userMax = bounds.userMax;

					var first = true;
					ctx.clearRect(0,0,750,355);
					ctx.restore();;
					ctx.beginPath();
					if(scope.values)
					{
						scope.values = $filter('orderBy')(scope.values,'+XValue')
						canvas.width = canvas.width;
						ctx.mozImageSmoothingEnabled = false;

						ctx.lineWidth = 6;
	     				ctx.strokeStyle = '#666';
						ctx.lineJoin = 'round';
						var step = ( 750 / scope.values.length );
						scope.values.walk(function(o,i){

                            const valueInPercent = (o.YValue - userMin) / (userMax - userMin);
                            var y = valueInPercent * 350;
							//console.log('VAL:'+o.XValue+'Y;'+o.YValue+'-LineTo:'+y+'Y:'+(i*step));
							if(first == true)
							{
								ctx.moveTo( ( (i +0.5)  * step )+ scope.offsetX, (350-y)+scope.offsetY );
								first= false;
							}
							ctx.lineTo( ( (i +0.5 )  * step )+ scope.offsetX, (350-y) +scope.offsetY);
						})
						ctx.stroke();
     				}


				}

              }

        };
        return obj ;


   }]);

